import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import api from '../config.json';
import axios from '../httpServices/httpService';
import _ from 'lodash'
import XLSX from 'xlsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';

const tableHead = ['RawMaterial', 'pmNo_Of_Shots', 'pmNo_Of_Days', 'alertNo_Of_Shots', 'alertNo_Of_Days', 'PM_CheckSheet', 'loading_CheckSheet', 'unloading_CheckSheet', 'DailyCheckSheet', 'Readiness', 'PM_Preparation_CheckSheet', 'Setup', 'HealthCheckUP']
const excelStructure = [{
  fieldName: 'RawMaterial',
  originalName: 'RawMaterial',
  objectName: 'Plastic_Raw_Material',
  separator: ',',
}, {
  fieldName: 'pmNo_Of_Shots',
  originalName: 'No_Of_Shots',
  objectName: 'PreventiveMaintenance_Plan',
  separator: ',',
},
{
  fieldName: 'pmNo_Of_Days',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Plan',
  separator: ',',
},
{
  fieldName: 'alertNo_Of_Shots',
  originalName: 'No_Of_Shots',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
},
{
  fieldName: 'alertNo_Of_Days',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
},


{
  fieldName: 'PM_CheckSheet',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
  arrayofcheckSheet: true
}
  , {
  fieldName: 'loading_CheckSheet',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
  arrayofcheckSheet: true
}
  , {
  fieldName: 'unloading_CheckSheet',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
  arrayofcheckSheet: true
}, {
  fieldName: 'DailyCheckSheet',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
  arrayofcheckSheet: true
}, {
  fieldName: 'Readiness',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
  arrayofcheckSheet: true
}, {
  fieldName: 'PM_Preparation_CheckSheet',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
  arrayofcheckSheet: true
}, {
  fieldName: 'Setup',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
  arrayofcheckSheet: true
}
  , {
  fieldName: 'HealthCheckUP',
  originalName: 'No_Of_Days',
  objectName: 'PreventiveMaintenance_Alert',
  separator: ',',
  arrayofcheckSheet: true
}
]
const Excelimport = () => {


  const [MoldMasterList, setMoldMasterList] = useState([]);
  const [sortColumn, setSortColumn] = useState({ path: 'MoldId', order: 'asc' });
  const [querySuccess, setQuerySuccess] = useState(true);
  const [excelData, setExcelData] = useState([]);
  const [errors, setErrors] = useState(null);
  const [errorModal, setErrorModal] = useState(false);
  const [rowNumber, setRowNumber] = useState(0);
  const [errorFlag, setErrorFlag] = useState(false);
  const [objKey, setObjKey] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleUploadGuagesDoc = () => {
    let link = document.createElement('input');
    link.setAttribute('type', 'file');
    link.setAttribute('name', 'EquipmentList');
    let self = this;

    document.body.appendChild(link);
    link.click();

    link.onchange = async function (e) {
      e.preventDefault();
      let fr = new FileReader();
      fr.readAsBinaryString(e.currentTarget.files[0]);
      fr.onloadend = async function (e) {
        const wb = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        let dataArray = [];
        let keyArr = data[0];
        let arr = data.slice(1, data.length);
        arr.forEach((oneArr) => {
          let obj = {};
          let tetsArray = [];
          oneArr.forEach((value, i) => {
            if (value === 'YES') {
              obj[[keyArr[i]]] = true;
            } else if (value === 'NO') {
              obj[[keyArr[i]]] = false;

            }
            else if (tableHead.includes(keyArr[i])) {

              const filterdObject = excelStructure.filter(item => item.fieldName === keyArr[i]);
              console.log(filterdObject, 'cbhv')
              if ((filterdObject[0].arrayofcheckSheet)) {
                const versions = value.toString().split(',')

                let array = versions.map(version => {
                  return { CheckSheet: version.split('/')[0], Version: (version.split('/')[1]) }
                })
                console.log(array, "xdwuxbhe")
                obj[[keyArr[i]]] = array;


              } else {


                let separatedValues = typeof value === 'number' ? value : value.toString().split(filterdObject[0].separator);
                if (separatedValues && typeof separatedValues === 'string' || typeof separatedValues === 'number') {
                  if (!obj[filterdObject[0].objectName]) {
                    obj[filterdObject[0].objectName] = {};
                  }
                  obj[filterdObject[0].objectName][filterdObject[0].originalName] = Number(value);
                } else {
                  separatedValues.forEach((one) => tetsArray.push({ [filterdObject[0].originalName]: one.toLowerCase() }))
                  obj[filterdObject[0].objectName] = tetsArray;
                }
              }

            } else if (keyArr[i] && typeof value === 'number') {
              obj[[keyArr[i]]] = Number(value);

            } else {
              obj[[keyArr[i]]] = value.toString();
            }
          });
          dataArray.push(obj);
        });

        setExcelData(dataArray);
        console.log(dataArray, "imported excel data")
        // return
        await sendDataToServer(dataArray, dataArray, 0);
      };
    };
    document.body.removeChild(link);
  };
  const sendDataToServer = async (DataArray, originalDataArray, idx) => {
    setQuerySuccess(true);
    for (let index = idx; index < DataArray.length; index += 1) {
      try {
        // let error = valid.validate(DataArray[index], this.schema);
        let error = null

        if (error !== null) {
          let row = index + 1;
          setErrors(error);
          setQuerySuccess(false);
          setErrorModal(true);
          setRowNumber(row);
          break;
        } else {
          let res = await axios.post(api.api + 'UploadExcelMouldMasterData', { row: index + 1, data: DataArray[index] });
          const result = await axios.get(api.api1 + 'MoldMaster');
          setMoldMasterList(result.data);
          if (result.status == 200) {
            toast.success('🦄  Mould Saved - '
              //  DataArray[index].EquipmentID
              , {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
          }
        }
      } catch (err) {
        if (err.response.data.code === 500) {
          console.log(err.response.data, "eivbibv")
          let message = err.response.data.message

          AbortAndResumeProcess(message, DataArray, originalDataArray, index);
        }
        if (err.response.data.code === 11000) {
          let message = err.response.data.message;

          AbortAndResumeProcess(message, DataArray, originalDataArray, index);
        } else {
          let message = (err.response.data.message);

          console.log(err.response.data, "vsivbifv")
          //   let message = JSON.parse(err);

          setQuerySuccess(false);

          setObjKey(message.key);
          setErrorMessage(message.message);
          setErrorFlag(true);
          // if (message.key === 'DeviceID') {
          //   swal(`${message.message}  , \n  Please contact leafnet admin customer support !`, { dangerMode: true });
          // } else {
          //   insertIfNotExistDataTypeAndResumeProcess(message.message, message.key.toLowerCase(), message.key, DataArray[index][message.key], originalDataArray, index);
          // }
        }
        break;
      }
    }
    setQuerySuccess(false);
  };
  const AbortAndResumeProcess = (message, dataArray, originalArr, index) => {
    let row = index + 1;
    swal({
      title: "Are you sure?",
      text: message + row + ' Do you want skip it ',
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        index = index + 1;
        sendDataToServer(dataArray, originalArr, index)
      } else {
        // this.setState({querySuccess:false,arrayProcessIndex:index})
        swal('Process  Abort', { dangerMode: true });

        // swal("Your imaginary file is safe!");
      }
    });
  }
  return (
    <button type="button" className="btn-sm btn-primary  mx-2"
      onClick={() => handleUploadGuagesDoc()}
    ><FontAwesomeIcon icon={faFileImport} /> Excel Import</button>
  )
}

export default Excelimport